import { Component, OnDestroy, OnInit } from '@angular/core';

import { CimaCore, Util, XmStore, XmStoreUtil } from 'core/services';
import { Subscription } from 'rxjs';
import { CmsDataDetail } from 'store/cms/models';
import { User } from 'store/user/models';
import { PLAN_EIGHT_PLAN_IDS } from 'core/constants';
import { DiscountPromoCollection } from 'store/promotions/discount-promotion/models';
import { planEligibilityDetails } from 'store/plan-eligibility/models/plan-eligibility';
@Component({
    selector: 'broadband-label',
    styleUrls: ['./broadband-label.scss'],
    templateUrl: './broadband-label.html',
    standalone: false
})
export class BroadbandLabelComponent implements OnInit, OnDestroy {
    public pageData: CmsDataDetail;
    public labelDetails: LabelSegmentDetails;
    public currentLabel: LabelDetails;
    public activePlanId: string;
    public promoResponse: DiscountPromoCollection;
    public showXmcExclusionLabel: boolean = false;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private user: User;
    private cimaCore: CimaCore;

    constructor(xmStore: XmStore, cimaCore: CimaCore) {
        Object.assign(this, { xmStore, cimaCore });
    }

    public ngOnInit(): void {

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<DiscountPromoCollection>(DiscountPromoCollection), (result: DiscountPromoCollection) => {
            this.promoResponse = result;
        }));
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<User>(User), (user: User) => {
            this.user = user;

            this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
                this.pageData = pageData;
            }));

            if (user.account.isSegmentSix && !this.cimaCore.isBusinessUser && user.account?.isNYCustomer) {
                this.subscriptions.push(this.xmStore.peek<planEligibilityDetails>(planEligibilityDetails, { returnUndefined: true })
                    .subscribe((eligibility: planEligibilityDetails) => {
                        if (eligibility) {
                            this.showXmcExclusionLabel = Boolean(
                                eligibility.currentPlan.planCode === PLAN_EIGHT_PLAN_IDS.MOBILE_SELECT &&
                                !eligibility.eligiblePlans?.Unlimited?.some((plan: EligiblePlanDetails) => plan.planCode === PLAN_EIGHT_PLAN_IDS.MOBILE_PLUS)
                            );
                            this.buildLabelDetails();
                        }
                    })
                );
            }
            this.buildLabelDetails();
        }));
    }

    public tabChange(planId: string): void {
        this.activePlanId = planId;
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    private buildLabelDetails(): void {
        this.labelDetails = this.pageData?.broadbandLabel?.find(
            (label: LabelSegmentDetails) => this.showXmcExclusionLabel ? label.level === 'LEVEL_6_XMC_EXCLUDED'
                :this.user.account.level === 'LEVEL_5'
                    ? label.level === 'LEVEL_5_Plans_7.0' : label.level === this.user.account.level
        );
        // Add :PROMO suffix to plan IDs if promo eligibility criteria are met
        if (this.labelDetails && this.promoResponse?.isPlans8PromoEligible) {
            this.labelDetails.plans.forEach((plan: LabelDetails) => {
                if (!plan.planId.includes(':PROMO')) {
                    plan.planId = plan.planId + ':PROMO';
                }
            });
        }
        this.currentLabel = this.labelDetails?.plans[0];
        this.activePlanId = this.currentLabel?.planId;
    }
}
